// extracted by mini-css-extract-plugin
export default {"basicBtn":"index_basicBtn__EWN6a","wrapper":"index_wrapper__K5MAp","confirmBtn":"index_confirmBtn__lMNtp","message":"index_message__GZXeI","canceLBtn":"index_canceLBtn__9xbTI"};